// Info icon js

document.addEventListener("DOMContentLoaded", function () {
  // 1. Open modal when clicking info icon
  document.querySelectorAll(".product-info-text").forEach(function (textEl) {
    textEl.addEventListener("click", function () {
      let modalTarget = textEl.getAttribute("data-modal-target");
      if (modalTarget) {
        let modal = document.querySelector(modalTarget);
        if (modal) {
          modal.style.display = "block";
          document.documentElement.style.overflow = "hidden";
        }
      }
    });
  });

  

  // 2. Close modal when clicking close button
  document.querySelectorAll(".info-modal-close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      let modal = btn.closest(".info-modal");
      if (modal) {
        modal.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    });
  });

  // 3. Close modal when clicking on backdrop
  document.querySelectorAll(".info-modal").forEach(function (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    });
  });
});


// Shopify chat widget open js

document.addEventListener('DOMContentLoaded', function() {
  // Select all elements with class 'custom-live-chat-link'
  const chatLinks = document.querySelectorAll('.custom-live-chat-link');
  
  if (chatLinks.length > 0) {
    chatLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent default link behavior
        
        // Target the Shopify Inbox widget
        const shopifyChatWidget = document.querySelector('#ShopifyChat');
        if (shopifyChatWidget) {
          // Access shadow DOM
          const shadowRoot = shopifyChatWidget.shadowRoot;
          if (shadowRoot) {
            try {
              // Find the toggle button inside shadow DOM
              const toggleButton = shadowRoot.querySelector('.chat-toggle--bottom-right');
              if (toggleButton) {
                toggleButton.click(); // Trigger click to open/close widget
              } else {
                console.error('Chat toggle button not found in shadow DOM');
              }
            } catch (error) {
              console.error('Error accessing Shopify Inbox widget:', error);
            }
          } else {
            console.error('Shadow root not found for ShopifyChat widget');
          }
        } else {
          console.error('ShopifyChat widget not found');
        }
      });
    });
  }
});